module.exports = __webpack_public_path__ + "img/2012-12-14 20.12.07.6fa2d5ec.jpg";